// extracted by css-extract-rspack-plugin
export default {"root":"y9VDnz","text-block":"ZVc5et","textBlock":"ZVc5et","prefix":"nntaPm"};